import React from 'react';

export default function AccountTab({ accountSettings, handleSaveAccount, loading, setAccountSettings }) {
  return (
        <div className="glass-card">
          <h2 className="text-xl sm:text-2xl font-semibold text-white mb-6 sm:mb-8">Configurações da Conta</h2>
          <div className="space-y-6 sm:space-y-8">
            <div>
              <label className="block text-base font-medium text-gray-300 mb-3">
                Email
              </label>
              <input
                type="email"
                className="glass-input w-full text-base sm:text-sm"
                style={{ minHeight: '48px', padding: '12px 16px' }}
                value={accountSettings.email}
                onChange={(e) => setAccountSettings({ ...accountSettings, email: e.target.value })}
                placeholder="seu@email.com"
                data-testid="account-email-input"
              />
            </div>

            <div className="border-t border-white/10 pt-6 sm:pt-8">
              <h3 className="text-lg sm:text-xl font-semibold text-white mb-5 sm:mb-6">Alterar Senha</h3>
              <div className="space-y-5 sm:space-y-6">
                <div>
                  <label className="block text-base font-medium text-gray-300 mb-3">
                    Senha Atual
                  </label>
                  <input
                    type="password"
                    className="glass-input w-full text-base sm:text-sm"
                    style={{ minHeight: '48px', padding: '12px 16px' }}
                    value={accountSettings.current_password}
                    onChange={(e) => setAccountSettings({ ...accountSettings, current_password: e.target.value })}
                    placeholder="Digite sua senha atual"
                    data-testid="account-current-password-input"
                  />
                </div>

                <div>
                  <label className="block text-base font-medium text-gray-300 mb-3">
                    Nova Senha
                  </label>
                  <input
                    type="password"
                    className="glass-input w-full text-base sm:text-sm"
                    style={{ minHeight: '48px', padding: '12px 16px' }}
                    value={accountSettings.new_password}
                    onChange={(e) => setAccountSettings({ ...accountSettings, new_password: e.target.value })}
                    placeholder="Digite a nova senha"
                    data-testid="account-new-password-input"
                  />
                </div>

                <div>
                  <label className="block text-base font-medium text-gray-300 mb-3">
                    Confirmar Nova Senha
                  </label>
                  <input
                    type="password"
                    className="glass-input w-full text-base sm:text-sm"
                    style={{ minHeight: '48px', padding: '12px 16px' }}
                    value={accountSettings.confirm_password}
                    onChange={(e) => setAccountSettings({ ...accountSettings, confirm_password: e.target.value })}
                    placeholder="Confirme a nova senha"
                    data-testid="account-confirm-password-input"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end pt-4 sm:pt-6 border-t border-white/10">
              <button
                onClick={handleSaveAccount}
                disabled={loading}
                className="glass-button-primary w-full sm:w-auto"
                style={{ minHeight: '48px', padding: '12px 32px', fontSize: '16px' }}
                data-testid="account-save-button"
              >
                {loading ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          </div>
        </div>
  );
}
